module.exports = __webpack_public_path__ + "img/playstation-2.3fc1a147.png";